module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Social-Static-Ad-Mobile-w720.8d2499c0.webp";